import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, Form } from "antd";
import { FormServiceLayout } from "./layout.js";
import { useFormContentBlocker } from "../../contexts/formContentBlocker.js";
import { useFormService } from "../../contexts/formService.js";
import { useI18n } from "../../contexts/i18n.js";
const FormFieldTemplateSuccessorDeletionCheck = ({ type })=>{
    const { __ } = useI18n();
    const { template, isEdit } = type === "service" ? useFormService() : useFormContentBlocker();
    return template?.consumerData.successorOf.length > 0 && !isEdit && /*#__PURE__*/ _jsx(Form.Item, {
        name: "succeessorDeletionCheck",
        valuePropName: "checked",
        wrapperCol: {
            offset: FormServiceLayout.labelCol.span
        },
        children: /*#__PURE__*/ _jsx(Checkbox, {
            children: type === "service" ? __("Replace the previous service with this one. The old one should be deleted when this one is saved.") : __("Replace the previous content blocker with this one. The old one should be deleted when this one is saved.")
        })
    });
};
export { FormFieldTemplateSuccessorDeletionCheck };
